import React, { useState } from 'react'
import { FoodPeriodCategoryComponent } from '../Components/Category/FoodPeriodCategoryComponent';
import { KitchenComponent } from '../Components/Kitchen/KitchenComponent';

export const Kitchen = ({ setLoading, showMessage }) => {
  const [view, setView] = useState('Category');
  
  // حالت‌های مختلف برای ارسال
  const [categoryIds, setCategoryIds] = useState([]); // لیست دسته‌بندی‌های انتخاب شده
  const [categoryTitles, setCategoryTitles] = useState(''); // عنوان‌های دسته‌بندی‌ها
  const [categoryId, setCategoryId] = useState(-1); // یک categoryId (مثلاً اولین آیتم)

  const [currentPage, setCurrentPage] = useState(1);
  const [version, setVersion] = useState(0);
  const [id, setId] = useState(0);
  
  return (
    <>
      {view === "Category" ?
       
        <FoodPeriodCategoryComponent
          setLoading={setLoading}
          showMessage={showMessage}
          onClickItems={(id, ids, titles) => {
            setCategoryId(id); // اولین آیتم انتخاب شده
            setCategoryIds(ids); // کل لیست آیتم‌های انتخاب شده
            setCategoryTitles(titles); // عنوان‌ها
            setView("Search");
          }}
        />
        : <></>}
      {view == "Search" ?
        <KitchenComponent
          setLoading={setLoading}
          showMessage={showMessage}
          categoryId={categoryId} // ارسال یک categoryId
          categoryIds={categoryIds} // ارسال لیست categoryIds
          categoryTitles={categoryTitles} // اگر به عنوان‌ها نیاز دارید
          onBackClick={(e) => {
            setView("Category");
          }}
        /> : <></>
      }
    </>
  )
}